import { useEffect } from "react"
import { useLocation } from "react-router-dom"

export default function ScrollToTop() {
  const { pathname } = useLocation()

  useEffect(() => {
    // Don't scroll to top for home or post pages - scroll position is preserved
    // by keeping components mounted
    const isHomeOrPost = pathname === "/" || pathname.match(/^\/posts\/\d+/)
    
    if (!isHomeOrPost) {
      // Scroll to top for other navigations
      const scrollContainer =
        document.getElementById("home-screen-container") ||
        document.getElementById("page-scroll-container")
      
      if (scrollContainer) {
        scrollContainer.scrollTop = 0
      }
    }
  }, [pathname])

  return null
}
